import { render, staticRenderFns } from "./PartnerTemplate.vue?vue&type=template&id=ee6bb84c&scoped=true&"
import script from "./PartnerTemplate.vue?vue&type=script&lang=js&"
export * from "./PartnerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTemplate.vue?vue&type=style&index=0&id=ee6bb84c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6bb84c",
  null
  
)

export default component.exports